import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Image } from 'react-bootstrap';
import './style/Team.css';

const teamMembers = [
  {
    name: 'Nadia Bertoldo',
    role: 'TNPEE',
    image: '/assets/bertoldo-nadia.jpg',
    email: 'bertoldo.nadia@gmail.com',
    phone: '3397227567',
  },
  {
    name: 'Stefano Lovato',
    role: 'TNPEE',
    image: '/assets/lovato-stefano.jpg',
    email: 'stefanolovato.tnpe@gmail.com',
    phone: '3202333766',
  },
  {
    name: 'Adriana Salese',
    role: 'TNPEE',
    image: '/assets/salese-adriana.jpg',
    email: 'tnpe.a.salese@gmail.com',
    phone: '3517402328',
  },
];

const Team = () => {
  return (
    <div className="team">
      <Helmet>
        <title>Chi siamo - Studio Vinzaglio 24</title>
        <meta
          name="description"
          content="Scopri il nostro team di professionisti altamente qualificati in riabilitazione neuropsicomotoria a Torino."
        />
        <meta property="og:title" content="Team - Studio Vinzaglio 24" />
        <meta
          property="og:description"
          content="Il nostro team di esperti è pronto a supportare i bambini e le famiglie con interventi mirati e professionali a Torino."
        />
        {/* <meta
          property="og:image"
          content="https://www.studiovinzaglio24.com/assets/og-team.jpg"
        /> */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.studiovinzaglio24.com/chi-siamo"
        />
        <link
          rel="canonical"
          href="https://www.studiovinzaglio24.com/chi-siamo"
        />
      </Helmet>

      <Container>
        <h2 className="team-title">Chi siamo</h2>
        <Row className="justify-content-center">
          {teamMembers.map((member) => (
            <Col key={member.name} xs={12} className="team-member">
              <Image
                src={member.image}
                alt={member.name}
                className="team-member-image"
                roundedCircle
                fluid
              />
              <h3 className="team-member-name">{member.name}</h3>
              <p className="team-member-role">{member.role}</p>
              <a
                href={`mailto:${member.email}`}
                onClick={(e) => e.stopPropagation()}
                rel="noreferrer"
                target="_blank"
              >
                {member.email}
              </a>
              <br />
              <a href={`tel:${member.phone}`}>{member.phone}</a>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Team;
